import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import authService from "../../services/authService";
import styles from "./loginOtp.module.css";
import { useState } from "react";
export default function VerifyLoginOtp() {
  const navigate = useNavigate();
  const location = useLocation();
  const login = location.state?.login;
  const [loading, setLoading] = useState(false);
  // Use array of 6 for OTP digits
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: { otp: ["", "", "", "", "", ""] },
  });
  if (!login) {
    navigate("/login/otp");
    return null;
  }
const onSubmit = async (data) => {
  const otp = data.otp.join("");
  try {
    setLoading(true); // 👈 start loading
    await authService.verifyLoginOtp(login, otp);
    toast.success("Login successful");
    navigate("/", { replace: true });
  } catch (err) {
    toast.error(err?.response?.data?.message || "Invalid OTP");
  } finally {
    setLoading(false); // 👈 stop loading
  }
};
  const otpValues = watch("otp");
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <h4 className={styles.title}>Verify OTP</h4>
          <p className={styles.otpInfo}>
            OTP sent to <strong>{login}</strong>.
            <span
              className={styles.link}
              onClick={() => navigate("/login/otp")}
            >
              Change
            </span>
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.inputGroup}>
              {otpValues.map((_, index) => (
                <input
                  key={index}  
                  type="text"
                  maxLength={1}
                  className={styles.otpInput}
                  {...register(`otp.${index}`, { required: true })}
                  onInput={(e) => {
                    const value = e.target.value;
                    if (!/^\d*$/.test(value)) {
                      // Only allow digits
                      setValue(`otp.${index}`, "");
                      return;
                    }
                    setValue(`otp.${index}`, value);
                    if (value && e.target.nextSibling) {
                      e.target.nextSibling.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    // Handle backspace to focus previous input
                    if (
                      e.key === "Backspace" &&
                      !otpValues[index] &&
                      e.target.previousSibling
                    ) {
                      e.target.previousSibling.focus();
                    }
                  }}
                />
              ))}
            </div>
            {errors.otp && (
              <p className={styles.error}>OTP is required (6 digits)</p>
            )}
         <button
  className={styles.button}
  disabled={loading}
>
  {loading ? "Logging in..." : "Login"}
</button>
          </form>
        </div>
      </div>
    </div>
  );
}